<template>
  <div>
    <ControlPanel :title="'Раздел: Документы'" :icon="'mdi mdi-folder'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos1>
          <p>В этом разделе можно сформировать документы на основе рассчитаных и сохраненных данных о зарплате, такие как расчетные листки или справки о заработной плате.</p>
        </template>

        <template v-slot:pos2>
          <table class="table table-sm table-bordered">
            <tr>
              <td><b-link to="/docs/salarycertificate/">Справка о заработной плате</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/docs/payslip/">Расчётный листок сотрудника</b-link></td>
            </tr>
          </table>
        </template>
      </Category>
    </div>
  </div>
</template>

<script>
import ControlPanel from "@/components/base/ControlPanel";
import Category from "@/components/base/Category";
import {mapGetters} from "vuex";

export default {
  name: 'DocsDefault.vue',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {

    }
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
}
</script>

<style scoped>

</style>